import { z } from "zod/v4";

export const UploadCogsDataRequestBodySchema = z.object({
  bucket: z.string(),
  key: z.string(),
});

export type UploadCogsDataRequestBodyType = z.infer<
  typeof UploadCogsDataRequestBodySchema
>;

export interface UploadCogsDataResponse {
  ignored: number;
  duplicate: number;
  unchanged: number;
  changed: number;
}
